/**
 * Image Ratings API Functions
 *
 * API calls for rating generated images in the gallery.
 */

import { apiClient } from '../api-client';

// ===========================================
// TYPES
// ===========================================

export interface MyImageRating {
  rating: number | null;
  comment?: string;
}

export interface ImageRatingResponse {
  success: boolean;
  rating: number;
  average: number;
  count: number;
}

export interface DeleteImageRatingResponse {
  success: boolean;
  message?: string;
}

// ===========================================
// RATING FUNCTIONS
// ===========================================

/**
 * Rate or update rating for an image
 */
export async function rateImage(
  imageId: string,
  rating: number,
  comment?: string
): Promise<ImageRatingResponse> {
  const response = await apiClient.post(`/api/v1/images/${imageId}/rate`, {
    rating,
    comment,
  });
  return response.data;
}

/**
 * Get user's current rating for an image
 */
export async function getUserImageRating(imageId: string): Promise<MyImageRating> {
  const response = await apiClient.get(`/api/v1/images/${imageId}/rating`);
  return response.data;
}

/**
 * Delete user's rating for an image
 */
export async function deleteImageRating(imageId: string): Promise<DeleteImageRatingResponse> {
  const response = await apiClient.delete(`/api/v1/images/${imageId}/rating`);
  return response.data;
}
